<script>
  import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

  const goToSpecialPage = () => {
    dispatch("go-to-special-page")
  }
</script>

<div class="slidelogos-container">
  <div class="slidelogo">
    <a href="static/files/volantino.pdf">
      <img title="Scarica il Volantino" src="static/images/por.png" alt="" />
    </a>
  </div>
  <div class="slidelogo second-logo">
    <a href="static/files/informativa.docx">
      <img title="Scarica l'informativa" src="static/images/por.png" alt="" />
    </a>
  </div>
  <div class="slidelogo pointer" on:click={goToSpecialPage}>
    <img title="Una regione più grande" src="static/images/por.png" alt="Una regione più grande" />
  </div>
</div>

<style>
  .slidelogo {
    border: solid 4px #ffc000;
    transition: 350ms;
    position: fixed;
    background-color: #fff;
    bottom: 50px;
    right: -230px;
    height: 100px;
    min-width: 350px;
  }

  .slidelogo:nth-child(3) {
    bottom: 271px !important;
  }

  .slidelogo:nth-child(2) {
    bottom: 160px !important;
  }

  .slidelogo:hover {
    right: 0px;
  }

  .slidelogos-container img {
    height: 100%;
  }

  .third-logo {
    box-sizing: border-box;
    margin: 8px;
    padding: 30px 0px 10px 10px;
  }
  
  @media (max-width: 480px) {
    .slidelogo {
      height: 70px;
      right: -270px;
      bottom: 50px;
    }
    .slidelogo:nth-child(2) {
      bottom: 130px !important;
    }
    .slidelogo:nth-child(3) {
      bottom: 202px !important;
    }
  }
</style>
